import type { ResetPasswordState } from '@/pages/ResetPassword/reset-password';

import type { ResetPasswordFormValues } from '@/schemas/auth.schema';
import type { ChangePasswordFormValues } from '@/schemas/user.schema';

import type { AuthResponse, ResetPasswordChallenge } from '@/types/auth.type';

export const mapAuthResponse = (
  response: Record<string, Record<string, string>>
): AuthResponse | ResetPasswordChallenge => {
  const payload = response.data;

  if (payload.type === 'RESET_PASSWORD_CHALLENGE') {
    return {
      type: 'RESET_PASSWORD_CHALLENGE',
      session: payload.session,
      name: payload.name,
      email: payload.email,
    };
  }

  return {
    type: 'LOGIN',
    access_token: payload.access_token,
    refresh_token: payload.refresh_token,
    expires_in: Number(payload.expires_in),
  };
};

export const mapChangePasswordRequest = (
  data: ChangePasswordFormValues
): Record<string, string> => {
  return {
    new_password: data.new_password,
    old_password: data.current_password,
  };
};

export const mapResetPasswordRequest = (
  data: ResetPasswordFormValues,
  extra: ResetPasswordState
): Record<string, string> => {
  return {
    session: extra.session,
    username: extra.username,
    first_name: data.first_name,
    name: extra.name,
    last_name: data.last_name,
    new_password: data.new_password,
  };
};
